__turbopack_context__.v({
  "backToTop": "Rows-module__A_uAqa__backToTop",
  "dynamicRows": "Rows-module__A_uAqa__dynamicRows",
});
